import { mainAxios } from "../mainAxios";
import { getDefaultHeaders, getErrorMessage } from "./mainService";

export const getCuotasByEmisionId = async (emisionId) => {
        try {
        const response = await mainAxios.get(
            `/v1/cuota/cuotaByEmisionId/${emisionId}`,
            getDefaultHeaders()
        );
        return response.data;
    } catch (error) {
        throw new Error(getErrorMessage(error));
    }
};
